import axios from "axios";
import authHeader from '../../../authheader'

const PLSREINSTATEMENTURL = process.env.REACT_APP_APIURL + "/api/IndividualPlsReinstatement";

const getViolation = (reinstatementId) => {
    return axios.get(`${PLSREINSTATEMENTURL}/violation`, { headers: authHeader(), params: { reinstatementId } });
}
const postViolation = (data) => {
    return axios.post(`${PLSREINSTATEMENTURL}/violation`, data, { headers: authHeader() });
}
const downloadViolationFile = (reinstatementId) => {
    axios.get(`${process.env.REACT_APP_APIURL}/Reports/GetReinstatementViolationsForm`, { headers: authHeader(), params: { reinstatementId }, responseType: 'arraybuffer' }).then((response) => {
        var name = new String(response.headers['content-disposition']);
        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', name.slice(name.indexOf('filename=') + 9, name.lastIndexOf(';')));
        document.body.appendChild(link);
        link.click();
        link.remove();
    });
}
export default {
    getViolation,
    postViolation,
    downloadViolationFile
}